import { isFunction } from "lodash";
import SearchInputLight from "../inputs/SearchInputLight";
import TitledHeader from "./TitledHeader";

const TitledHeaderWithSearch = ({
  title,

  titleTopContent,
  titleContent,
  titleEndContent,
  titleStartContent,
  variant,
  hideBottomBorder,
  quickFilter,
  borderColor,
  setQuickFilter,
  endContent,
  searchPlaceholder,
  sx,
  children,
}) => {
  return (
    <TitledHeader
      title={title}
      sx={sx}
      setQuickFilter={setQuickFilter}
      endContent={endContent}
      titleTopContent={titleTopContent}
      titleContent={titleContent}
      titleEndContent={titleEndContent}
      titleStartContent={titleStartContent}
      variant={variant}
      hideBottomBorder={hideBottomBorder}
      borderColor={borderColor}
      titleBottomContent={
        isFunction(setQuickFilter) ? (
          <SearchInputLight
            value={quickFilter}
            onChange={setQuickFilter}
            placeholder={searchPlaceholder}
            sx={{ input: { padding: 0 } }}
          />
        ) : null
      }
    >
      {children}
    </TitledHeader>
  );
};

export default TitledHeaderWithSearch;
